import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-layout',
	templateUrl: './layout.component.html',
})
export class LayoutComponent implements OnInit {
	active = 1
	isOpen = window.innerWidth >= 1024 ? true : false
	constructor(public translate: TranslateService) {}
	ngOnInit(): void {}
}
